import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'school-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  providers: [DatePipe]

})
export class DeleteDialogComponent implements OnInit {

  message: string = "Are you sure?"
  confirmButtonText = "Yes"
  cancelButtonText = "Cancel"
  imm_vac_periods = false;

  today = new Date();
  taken_date: Date;
  taken_status: boolean;

  constructor(
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DeleteDialogComponent>) {
    if (data) {
      this.message = data.message || this.message;
      this.imm_vac_periods = data.vac_periods;
      this.taken_status = data.status;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }

  ngOnInit(): void {

  }

  onConfirmClick(): void {
    this.data.taken_date = this.datePipe.transform(this.taken_date, 'y-MM-dd');
    this.dialogRef.close(this.data);
  }

}
